register('feature-slider', {
  onLoad() {
    const rowsSlider = this.container.querySelector('[tiny-slider]');
    this._featureSlider(rowsSlider);
    const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (winWidth >= 768) {
      new ResponsiveAutoHeight(this.container.querySelectorAll('.js-auto-height'));
    }
  },
  _featureSlider(rowsSlider){
    if (!rowsSlider) { return; }
    const imagewithtextSlider = tns({
      container: rowsSlider,
      items: 1,
      slideBy: 'page',
      gutter: 0,
      center: false,
      autoplay: false,
      controls: false,
      nav: false,
      navPosition: 'bottom',
      mouseDrag: true,
      autoHeight: true,
      startIndex: 0,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          nav: true,
          mouseDrag: false,
          autoHeight: true,
        }
      }
    });
    var info = imagewithtextSlider.getInfo();
    rowsSlider.querySelectorAll('.tns-controls--customize button[data-controls]').forEach(btn => {
      btn.setAttribute('tabindex', '-1');
    })
    for (var i = 0; i < info.slideItems.length ; i++) {
      let el = info.slideItems[i];

      if ( i >= parseInt(info.index) && i < (parseInt(info.index) + parseInt(info.slideBy)) ) {
        el.removeAttribute('tabindex');
        el.querySelector('iframe') ? el.querySelector('iframe').removeAttribute('tabindex') : !1;
        el.querySelectorAll('.tns-controls--customize button[data-controls]').forEach(btn => {
          btn.removeAttribute('tabindex');
        })
      }else{
        el.setAttribute('tabindex', '-1');
        el.querySelector('iframe') ? el.querySelector('iframe').setAttribute('tabindex', '-1') : !1;
      }
    }

    const coltrol_btns = rowsSlider.querySelectorAll('.tns-controls--customize button');
    coltrol_btns.forEach(btn => {
        btn.addEventListener('click', (e) =>{
            if (btn.getAttribute('data-controls') == 'prev') {
                imagewithtextSlider.goTo('prev');
            }else{
                imagewithtextSlider.goTo('next');
            }
        })
    });
    const nav_btns = rowsSlider.querySelectorAll('.tns-nav--customize button');
    nav_btns.forEach(btn => {
        btn.addEventListener('click', (e) =>{
            const index = btn.getAttribute('data-nav') || 0;
            imagewithtextSlider.goTo(index);
        })
    });
    imagewithtextSlider.events.on('indexChanged', function(info,eventName){
        var indexPrev = info.slideItems[info.indexCached].getAttribute('data-slide'),
        indexCurrent = info.slideItems[info.index].getAttribute('data-slide');

        nav_btns.forEach(btn => {
            //console.log(navCurrent, indexPrev);
            if (btn.getAttribute('data-nav') == indexCurrent ) {
                btn.classList.add('tns-nav-active');
            }else{
                btn.classList.remove('tns-nav-active');
            }
        })

        rowsSlider.querySelectorAll('.tns-controls--customize button[data-controls]').forEach(btn => {
          btn.setAttribute('tabindex', '-1');
        })
        for (var i = 0; i < info.slideItems.length ; i++) {
          let el = info.slideItems[i];
          if ( i >= parseInt(info.index) && i < (parseInt(info.index) + parseInt(info.slideBy)) ) {
            el.removeAttribute('tabindex');
            el.querySelector('iframe') ? el.querySelector('iframe').removeAttribute('tabindex') : !1;
            el.querySelectorAll('.tns-controls--customize button[data-controls]').forEach(btn => {
              btn.removeAttribute('tabindex');
            })
          }else{
            el.setAttribute('tabindex', '-1');
            el.querySelector('iframe') ? el.querySelector('iframe').setAttribute('tabindex', '-1') : !1;
          }
        }
    });
    imagewithtextSlider.events.on('newBreakpointEnd', function(info, eventName){
        imagewithtextSlider.updateSliderHeight()
    });
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});

load('feature-slider');